import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {AbstractControl, FormControl, UntypedFormControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export const markFormGroupTouched = (formGroup): void => {
    (<any>Object).values(formGroup.controls).forEach(control => {
        control.markAsTouched();

        if (control.controls) {
            markFormGroupTouched(control);
        }
    });
};

export const updateValueAndValidityOfFormGroup = (formGroup): void => {
    Object.values(formGroup.controls).forEach((formControl: FormControl) => {
        formControl.updateValueAndValidity();
    });
};

export const setDisplayedListForPaginator =
    (sourceList: any[] = [], paginator: MatPaginator | undefined = <MatPaginator>{pageIndex: 0, pageSize: 10}): any[] => {

        let displayedList = [];

        if (sourceList.length > paginator.pageSize) {
            const firstPageIndex = paginator.pageIndex * paginator.pageSize;
            const lastPageIndex = sourceList.length > firstPageIndex + paginator.pageSize
                ? firstPageIndex + paginator.pageSize
                : sourceList.length;

            for (let i = firstPageIndex; i < lastPageIndex; i++) {
                displayedList[i - firstPageIndex] = sourceList[i];
            }
        } else {
            displayedList = sourceList;
        }
        return displayedList;
    };

export const isIEOrEdge = (): boolean => /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

export const runWithTimeoIfIEOrEdge = (callback: (arg?: any) => any, arg?: any): any => {
    if (isIEOrEdge()) {
        setTimeout(() => {
            runCallback(callback, arg);
        });
    } else {
        runCallback(callback, arg);
    }
};

function runCallback(callback: (arg?: any) => any, arg: any): any {
    if (arg !== undefined) {
        callback(arg);
    } else {
        callback();
    }
}

export const trimValue = (value: string | any): any => (value && (typeof value === 'string')) ? value.trim() : value;


export const nameHasNotAllowableCharacterValidator = (control: UntypedFormControl): { [s: string]: boolean } => {
    const hasNotAllowableNameCharacter = /[+]/.test(control.value);

    if (hasNotAllowableNameCharacter) {
        return {'nameHasNotAllowableCharacterError': true};
    }
    return null;
};

export const requiredCheckBoxValidator = (control: UntypedFormControl): { [s: string]: boolean } => !control.value ? {'required': true} : null;

export const NAME_CONTAINS_FORBIDDEN_CHARACTERS_MESSAGE = 'Name contains forbidden characters';

const URL_REGEXP = /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
const HOST_REGEXP = /^(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

export const isValidURL = (str): boolean => {
    return URL_REGEXP.test(str);
};

export const isValidHost = (str): boolean => {
    return isValidURL(str)
        || HOST_REGEXP.test(str);
};




export function isValidURLValidator(control: AbstractControl): ValidationErrors | null {
    return (!control.value || isValidURL(control.value))
        ? null
        : <ValidationErrors>{'invalidUrl': true};
}

export function isValidHostValidator(control: UntypedFormControl): ValidationErrors | null {
    return (!control.value || isValidHost(control.value))
        ? null
        : <ValidationErrors>{'invalidHost': true};
}

export function hasASCIICharactersOnlyValidator (control: UntypedFormControl): { [s: string]: boolean } {
    const hasASCIICharactersOnly = /^[\x00-\x7F]*$/.test(control.value);

    if (!hasASCIICharactersOnly && control.value) {
        return {'hasASCIICharactersOnly': true};
    }
    return null;
}

export function manageRequiredValidators(isRequired: boolean, formControl: FormControl): void {
    if (isRequired && !formControl.hasValidator(Validators.required)) {
        formControl.addValidators(Validators.required);
    } else {
        if (!isRequired && formControl.hasValidator(Validators.required)) {
            formControl.clearValidators();
        }
    }
}

export const isEqualToSomeValueValidator = (initialValue: string) => {
    return (control: AbstractControl) => {
        if (initialValue
            && (control?.value?.toLowerCase() === initialValue?.toLowerCase())) {
            return <ValidationErrors>{'isEqualToSomeValueError': true};
        }
        return null;
    };
};

export function transformMapObjectToSendAPIRequest(map: Map<any, any>): any {
    const mapObject = {};
    for (const [key, value] of map) {
        mapObject[key] = value;
    }
    return mapObject;
}

export function getBrowser(): {name: string; version: number } {
    const userAgent = navigator.userAgent;

    const getBrowsername = function () {
        const specString = userAgent;

        let matches = specString.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        // Work with the matches.
        matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];

        let temp;
        // Trident.
        if (/trident/i.test(matches[1])) {
            temp = /\brv[ :]+(\d+)/g.exec(specString) || [];
            return 'IE';
        }

        // Chrome.
        if (matches[1] === 'Chrome') {
            temp = specString.match(/\bOPR|Edge\/(\d+)/);
            if (temp != null) {
                return 'Opera';
            }
        }

        if ((temp = specString.match(/version\/(\d+)/i)) != null) {
            matches.splice(1, 1, temp[1]);
        }

        const name = matches[0];

        return name;
    };


    const getBrowserVersion = function() {
        const specString = userAgent;

        let matches = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

        // Work with the matches.
        matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];

        let temp, version;
        // Trident.
        if (/trident/i.test(matches[1])) {
            temp = /\brv[ :]+(\d+)/g.exec(specString) || [];
            version = (temp[1] || '');
            return version;
        }

        // Chrome.
        if (matches[1] === 'Chrome') {
            temp = specString.match(/\bOPR|Edge\/(\d+)/);
            version = temp[1];
            if (temp != null) {
                return version;
            }
        }

        if ((temp = specString.match(/version\/(\d+)/i)) != null) {
            matches.splice(1, 1, temp[1]);
        }

        version = matches[1];

        return version;
    };

    return {
        name: getBrowsername(),
        version: getBrowserVersion()
    };
}

export const getDigitsOnly = (value: string): string => {
    return (value?.toString().match(new RegExp(/\d*/g)) || []).filter((val: string) => !!val).join('');
}

export const US_PHONE_NUMBERS_WITHOUT_COUNTRY_CODE_LENGTH = 10;
export const UKR_PHONE_NUMBERS_WITH_COUNTRY_CODE_LENGTH = 12;
export const DaysOfWeekLongFriendly = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const DaysOfWeekLong = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export const DaysOfWeekShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
export const MonthDays = Array.from(Array(31).keys()).map((v: number) => v + 1); // 1-31
